import React from 'react'
import back from '../images/back.svg';
import plusPlay from '../images/open.svg'
import minusPlay from '../images/close.svg'
import apiUrls from '../common/apiUrls';
import { getContentHeaders, getGetApi } from '../common/axiosConfig';
import Loader from '../common/loader'
class Faq extends React.Component {
    constructor (props){
        super(props);
        this.state={
            showLoader:false,
            faqs : []
        }
    }
    componentDidMount = ()=>{
        this.getAboutUs();
    }
    goBack = () =>{
        this.props.history.goBack()
    }
    showLoader = () =>{
        this.setState({showLoader:true});
    }
    hideLoader = () =>{
        this.setState({showLoader:false});
    }

    getAboutUs = () =>{
        this.showLoader();
        getGetApi(apiUrls.faq,getContentHeaders()).then((response)=>{
            if(response.data.code == 2000){
               this.setState({faqs:response.data.data.content});
               this.hideLoader();
            }
        })
    
    }

    goBack = () =>{
        this.props.history.goBack()
    }

    toggleFaq(index){
        var currentFaq = this.state.faqs[index];
        currentFaq["open"] = !currentFaq.open;
        var list = this.state.faqs;
        list[index] = currentFaq;
        this.setState({faqs:list});
    }


    render() {
        return (
            <div className="container-bmi">
                 {this.state.showLoader && <Loader></Loader>}
                <div className="header-bmi ee">
                    <img src={back} onClick={this.goBack}></img>
                    <p>FAQ</p>
                </div>
                <div className="content-faq">
                    {
this.state.faqs.map((faq,index)=>
                        <div className="faq-ques" key={index}>
                        <div className="fq-left">
                    <p className="ques q-active">{faq.question}</p>
                            {faq.open && <p className="ans">{faq.answer}
                            </p>}
                        </div>
                        <div className="fq-right">
                            <img src={faq.open?minusPlay:plusPlay} onClick={()=>{this.toggleFaq(index)}}></img>
                        </div>
                    </div>)
                    }
                    
                   
                </div>
            </div>


        )
    }
}

export default Faq;